import React from 'react';
import { Section as SectionModel } from '../types';

export type SectionProps = {
  section: SectionModel;
};

const Section: React.FC<SectionProps> = ({ section }) => (
  <div style={{ marginTop: 16, marginBottom: 16 }}>
    <div className="h4 text-primary" style={{ fontWeight: 600 }}>
      {section.name.toUpperCase()}
    </div>
    {section.description && (
      <div style={{ fontSize: '1.2rem' }}>{section.description}</div>
    )}
  </div>
);

export default Section;
